export default __webpack_public_path__ + "static/media/united-kingdom.5233f022.png";